<template>
    <v-card class="mt-2 pt-2">
    <v-layout row mb-3>
        <v-flex pl-2 xs4>
            <img style="min-width:48px;min-height:24px; max-width:150px;max-height:100px;" :src="'http://image.galileo.co.th/Airline/'+ FlightFare.PricingBoxGroup[0].PricingBox[0].Airline + '.png'">
        </v-flex>
        <v-flex xs8 sm8>
          <v-card class="price-card" flat v-if="isMobile" style="background:transparent;">
              <v-layout row wrap>
                  <v-flex xs12 md12 mr-2>
                      <v-layout row wrap>                                 
                          <v-flex xs12 md12 class="text-xs-right">
                              <span>{{sellingCurrency.code}} {{helper.numberFormat.formatPrice(sellingCurrency.totalPrice)}}</span>
                          </v-flex>
                          <v-flex xs12 md12 class="text-xs-right">
                              <span :style="'font-size:11px;color:'+ primary">Tax included</span>
                          </v-flex> 
                      </v-layout> 
                  </v-flex>
              </v-layout>
          </v-card>
        </v-flex>
    </v-layout>
        <v-layout row wrap dvsectors>
          <v-flex xs12 md10>
            <div v-for="(fltpricegrp,indgrp) in FlightFare.PricingBoxGroup" :key="indgrp">                  
              <div :style="{marginLeft:'20px', marginRight:(isMobile?'20px':'0')}">
                  <div>
                      <v-chip color="primary" dark class="text-md-center text-xs-center">
                          <label style="width:65px;">{{getAirportCode(searchPara.originM[indgrp])}} - {{getAirportCode(searchPara.destinationM[indgrp])}}</label>
                          <!-- <label style="width:65px;">Departure</label> -->
                          <FlightIcon :DepartureReturnIndicator="'D'"/>
                      </v-chip>
                      <v-chip v-if="needDepartureFlight" color="red" dark><v-icon style="margin-right:5px;">warning</v-icon>Please select a flight of departure.</v-chip>
                  </div>
                  <v-radio-group row v-model="selectedDepartureFlightlst[indgrp].selectedDeparture" class="mt-1" v-for="(fltpricebox,ind) in fltpricegrp.PricingBox" :key="ind">
                      <v-layout row v-for="(fltDprt,index) in fltpricebox.FilteredDepartures" :key="index" 
                          :style="!isTransit(fltpricebox.FilteredDepartures,index) && (index < fltpricebox.FilteredDepartures.length-1 || ind < fltpricegrp.PricingBox.length-1)? 'padding-bottom:10px;border-bottom:solid 1px #e3dede;margin-right:5px;':''">
                              <v-flex xs4 md2 class="text-md-center" v-if="isTransit(fltpricebox.FilteredDepartures,index)">
                                  <v-radio 
                                      :color="primary" 
                                      :label="fltDprt.Flight.AirV + ' ' + fltDprt.Flight.FltNum" 
                                      :key="index" 
                                      :value="fltDprt.Flight.GroupFlightID"></v-radio>
                                  
                              </v-flex>
                              <v-flex xs4 md2 class="text-md-left" v-if="!isTransit(fltpricebox.FilteredDepartures,index)">
                                  <v-layout row>
                                      <v-flex md12>
                                          <div class="v-radio theme--light">
                                          <div class="v-input--selection-controls__input">
                                              <div class="v-input--selection-controls__ripple"></div>    
                                          </div><label aria-hidden="true" class="v-label theme--light" style="left: 0px; right: auto; position: relative;">{{fltDprt.Flight.AirV + ' ' + fltDprt.Flight.FltNum}}</label></div></v-flex>
                                  </v-layout>
                              </v-flex>
                              <v-flex xs8 md10>
                                  
                                  <OriginDestination :FlightInfo="fltDprt.Flight" :ConnectingFlightInfo="fltDprt.Flight.Conx=='Y'? fltpricebox.FilteredDepartures[index+1].Flight:null"/>
                              </v-flex>
                      </v-layout>
                        <div v-if="fltpricebox.Departures.length==1" style="visibility:hidden;height:0px;width:100%;">
                          <v-layout row v-for="(fltDprt,index) in fltpricebox.FilteredDepartures" :key="index">
                                  <v-flex md12>
                                      <OriginDestination :FlightInfo="fltDprt.Flight"/>
                                  </v-flex>
                          </v-layout>  
                      </div> 
                      
                  </v-radio-group>
              </div>
          </div>
          </v-flex>  
          <v-flex xs12 md2 class="price-grid-cell" style="padding-bottom:8px;">
              
              <v-container :class="('md,lg,xl'.indexOf(this.$vuetify.breakpoint.name)>=0? 'border-left':'') +' full-height pa-0'" :style="'border-left-color:' + primary">
                  <v-card class="price-card" flat>
                      <v-layout row wrap>
                          <v-flex xs6 md12 v-if="!isMobile">
                              <v-layout row wrap>
                                  <v-flex xs6 md12>
                                      <span>{{sellingCurrency.code}}</span>
                                  </v-flex>                                    
                                  <v-flex xs6 md12>
                                      <span>{{helper.numberFormat.formatPrice(sellingCurrency.totalPrice)}}</span>
                                  </v-flex>
                                  <v-flex xs12 md12>
                                      <span :style="'font-size:11px;color:'+ primary" >Tax included</span>
                                  </v-flex> 
                              </v-layout> 
                          </v-flex>
                          <v-flex xs12 md12 text-xs-center><v-btn color="primary" @click="selectFlights();">Book</v-btn></v-flex>
                      </v-layout>
                  </v-card>
              </v-container>
              
          </v-flex>  
        </v-layout>           
        <v-dialog
            v-model="flightInfoDialog.show"
            max-width="550"
            scrollable 
        >
            <v-card max-height="550">
                <v-card-title class="headline">Flight details</v-card-title>
                <v-card-text>
                    <v-tabs 
                        v-model="flightInfoDialog.selectedTab"
                    >
                        <v-tab href="#tab1">
                            Fares
                        </v-tab>
                        <v-tab href="#tab2">
                            Conditions
                        </v-tab>
                        <v-tabs-items v-model="flightInfoDialog.selectedTab">
                            <v-tab-item value="tab1">
                                <div style="position:relative;width:100%;height:300px;overflow-y:auto;">
                                    <div>
                                        <v-container class="text-xs-center" v-if="!infoLoaded">
                                            <v-progress-circular
                                            :size="50"
                                            color="primary"
                                            indeterminate
                                            ></v-progress-circular>
                                        </v-container>
                                        <v-container v-if="infoLoaded">
                                            <v-layout row wrap>
                                                <v-spacer></v-spacer>
                                                <v-flex xs4 sm3><label style="font-weight:bold;">Currency</label></v-flex>
                                                <v-flex xs4 sm3 text-xs-right><label style="font-weight:bold;">{{sellingCurrency.code}}</label></v-flex>
                                                <v-spacer></v-spacer>
                                            </v-layout>                                              
                                            <v-layout row wrap>
                                                <v-spacer></v-spacer>
                                                <v-flex xs8 sm6><label style="font-weight:bold;">Prices</label></v-flex>
                                                <v-spacer></v-spacer>
                                            </v-layout>                                        
                                            <v-layout row wrap v-for="(passenger,index) in farePassengers" :key="'p' +index">
                                                <v-spacer></v-spacer>
                                                <v-flex xs4 sm3>{{getPassengerTypeDesc(passenger.Type)}}</v-flex>
                                                <v-flex xs4 sm3 text-xs-right>{{passenger.Count + " x " + helper.numberFormat.formatPrice(showInSellingCurrency(passenger.Price))}}</v-flex>
                                                <v-spacer></v-spacer>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-spacer></v-spacer>
                                                <v-flex xs8 sm6><label><label style="font-weight:bold;">Taxes</label></label></v-flex>
                                                <v-spacer></v-spacer>
                                            </v-layout>                                         
                                            <v-layout row wrap v-for="(passenger,index) in farePassengers" :key="'t'+index">
                                                <v-spacer></v-spacer>
                                                <v-flex xs4 sm3>{{getPassengerTypeDesc(passenger.Type)}}</v-flex>
                                                <v-flex xs4 sm3 text-xs-right>{{passenger.Count + " x " + helper.numberFormat.formatPrice(showInSellingCurrency(passenger.Tax))}}</v-flex>
                                                <v-spacer></v-spacer>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-spacer></v-spacer>
                                                <v-flex xs8 sm6><label><label style="font-weight:bold;">Q Surcharge</label></label></v-flex>
                                                <v-spacer></v-spacer>
                                            </v-layout>                                         
                                            <v-layout row wrap v-for="(passenger,index) in farePassengers" :key="'q'+index">
                                                <v-spacer></v-spacer>
                                                <v-flex xs4 sm3>{{getPassengerTypeDesc(passenger.Type)}}</v-flex>
                                                <v-flex xs4 sm3 text-xs-right>{{passenger.Count + " x " + helper.numberFormat.formatPrice(showInSellingCurrency(passenger.QSercharge))}}</v-flex>
                                                <v-spacer></v-spacer>
                                            </v-layout>                                            
                                            <v-layout row wrap>
                                                <v-spacer></v-spacer>
                                                <v-flex xs4 sm3><label><label style="font-weight:bold;color:blue;">Total</label></label></v-flex>
                                                <v-flex xs4 sm3 text-xs-right><label><label style="font-weight:bold;color:blue;">{{helper.numberFormat.formatPrice(showInSellingCurrency(getTotalPrice(farePassengers)))}}</label></label></v-flex>
                                                <v-spacer></v-spacer>
                                            </v-layout>    
                                            <v-layout row wrap v-if="TotalPrice!=getTotalPrice(farePassengers)">
                                                <v-flex pt-3>
                                                    <v-icon style="color:orange;">warning</v-icon> Price change alert<br>
                                                    The selected price of {{currency}} <b style="color:red;"><strike>{{helper.numberFormat.formatPrice(TotalPrice)}}</strike></b> was changed by the airline. 
                                                    <br>New price is {{currency}} <b style="color:green;">{{helper.numberFormat.formatPrice(getTotalPrice(farePassengers))}}</b>.
                                                </v-flex>
                                            </v-layout>                                          
                                        </v-container>                                        
                                    </div>
                                </div>                                
                            </v-tab-item>
                            <v-tab-item value="tab2">
                                <v-container class="text-xs-center" v-if="!infoLoaded">
                                    <v-progress-circular
                                    :size="50"
                                    color="primary"
                                    indeterminate
                                    ></v-progress-circular>
                                </v-container>                                 
                                <div v-if="infoLoaded" style="position:relative;width:100%;height:300px;overflow-y:auto;">                                   
                                    <div v-for="(rule,index) in rules" :key="'C'+index">
                                        <label :style="getFareRuleLineStyle(rule.RulesDataType)" v-text="rule.RulesText"></label>
                                    </div>
                                </div>                                                                
                            </v-tab-item>                            
                        </v-tabs-items>
                    </v-tabs>

                </v-card-text>
                <v-card-actions>
                    <div class="text-xs-center" style="width:100%;">
                        <div>By clicking 'Continue' button you confirm you have read and accepted the fares and the conditions of your booking.</div>
                        <v-btn color="primary" flat @click="flightInfoDialog.show=false">Close</v-btn>
                        <v-btn color="primary" :disabled="continueButtonDisability" flat @click="continueToPassengerInfo()">Continue</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
/* eslint-disable */
import theme from '../../theme'
import helper from '../helper'
import OriginDestination from './OriginDestination'
import FlightIcon from './FlighIcon'
import Service from './FlightSearch.Service'

export default {
    props:[
        'FlightFare',
        'AdultCount',
        'ChildCount',
        'InfantCount',
        'TotalPrice',
        'DepartureTimeFilter',
        'SearchId',
        'searchPara',
    ],
    computed:{
        sellingCurrency () {
          const sc = {
            code: '',
            fxRate: 0.00,
            totalPrice: 0.00
          }
          if (this.FlightFare.PricingBoxGroup[0].PricingBox[0].SellingCurrency != null) {
            sc.code = this.FlightFare.PricingBoxGroup[0].PricingBox[0].SellingCurrency.CurrencyCode
            sc.fxRate = this.FlightFare.PricingBoxGroup[0].PricingBox[0].SellingCurrency.FxRate
            sc.totalPrice = Math.ceil(this.TotalPrice * sc.fxRate)
          } else {
            sc.code = this.FlightFare.Currency
            sc.fxRate = 1
            sc.totalPrice = this.TotalPrice
          }
          return sc;
        },
        // HasReturningFlight(){
        //     return this.FlightFare.FilteredReturns&&this.FlightFare.FilteredReturns.length>0;
        // },
        departureTimeFilter(){
            return this.DepartureTimeFilter==null? ['00:00','23:59']:this.DepartureTimeFilter;
        },
        continueButtonDisability(){          
            return !this.infoLoaded;
        },
        isMobile(){
            let isMobile = helper.display.isMobile(this.$vuetify.breakpoint.name);
            return isMobile;
        }, 
        // getFlightFareDeparture(){
        //     return this.reorderFlightGroups(this.flightFare.FilteredDepartures);
        // },
        // getFlightFareReturn(){
        //     return this.reorderFlightGroups(this.flightFare.FilteredReturns);
        // }         
    },
    created(){

    },
    updated(){
        //this.reorderFlightGroups();
    },
    components:{
        OriginDestination,FlightIcon
    },
    data(){
        return {
            flightFare:this.FlightFare,
            primary:theme.primary.base,
            helper:helper,
            selectedDepartureFlight:null,
            selectedReturnFlight:null,
            service:Service,
            flightInfoDialog:{
                show:false,
                tabs:['tab1','tab2'],
                selectedTab:'tab1',
            },
            rules:[],
            farePassengers:[],
            currency:"",
            infoLoaded:false,
            theme:theme,
            needDepartureFlight:false,
            needReturnFlight:false,
            selectedDepartureFlightlst:[{selectedDeparture:null},
                                    {selectedDeparture:null},
                                    {selectedDeparture:null},
                                    {selectedDeparture:null},
                                    {selectedDeparture:null},
                                    {selectedDeparture:null},
                                    {selectedDeparture:null},
                                    {selectedDeparture:null}],
        }
    },
    methods:{
        showInSellingCurrency(amount){
          const amnt = Math.ceil(amount * this.sellingCurrency.fxRate)
          return amnt
        },
        compareTotalPriceToConfirmedTotalPrice(confirmedPrice){
        },
        saveFareInfoOfSearch(priceBox,depFlightGrpId, cbFnc){
            Service.saveFareInfoOfSearchM(priceBox,depFlightGrpId).then((rslt)=>{

                for (let i =0;i<rslt.length;i++){
                    this.farePassengers[i]["passengerNo"] = rslt[i].passengerNo;
                    this.farePassengers[i]["searchId"] = rslt[i].searchId;
                    this.farePassengers[i]["fareId"] = rslt[i].fareId;
                    this.farePassengers[i]["ptc"] = rslt[i].ptc;
                }

                if (cbFnc!=null){
                    cbFnc();
                }
            });
        },
        continueToPassengerInfo(){
            var depFlightGrpIds=[];
            var priceBoxId = [];
            for(let i=0;i<this.searchPara.totalSector;i++){
                if(this.selectedDepartureFlightlst[i].selectedDeparture!=null){
                    depFlightGrpIds.push(this.selectedDepartureFlightlst[i].selectedDeparture);
                }
            }
            let selFlights = {
                FilteredDepartures:[],                
                FilteredReturns:[]
            }

            let selFlightsNew = [];

            let totsector=this.searchPara.totalSector;
            let origin=this.searchPara.originM;
            let destination=this.searchPara.destinationM;

            this.flightFare.PricingBoxGroup.forEach(prigrp => { 
                let fltlst={FilteredDepartures:[]};           
                prigrp.PricingBox.forEach(priceBox => {                    
                    // depFlightGrpIds.indexOf()
                    let isSelected=false;
                    priceBox.FilteredDepartures.forEach(f=>{
                    if (depFlightGrpIds.indexOf(f.Flight.GroupFlightID) >-1){
                        selFlights.FilteredDepartures.push(f);
                        isSelected=true;
                        fltlst.FilteredDepartures.push(f);
                    }
                    if(isSelected && priceBoxId.indexOf(priceBox.PricingBoxID) < 0){
                        priceBoxId.push(priceBox.PricingBoxID);
                    }
                });
                });
                if(fltlst.FilteredDepartures.length>0){
                    selFlightsNew.push(fltlst);
                }
            });

            // let priceBoxId = this.FlightFare.PricingBoxID;            
            
            // this.flightFare.FilteredDepartures.forEach(f=>{
            //     if (f.Flight.GroupFlightID==this.selectedDepartureFlight){
            //         selFlights.FilteredDepartures.push(f);
            //     }
            // });

            // if (this.flightFare.FilteredReturns){
            //     this.flightFare.FilteredReturns.forEach(f=>{
            //         if (f.Flight.GroupFlightID==this.selectedReturnFlight){
            //             selFlights.FilteredReturns.push(f);
            //         }
            //     });
            // }


            let fnc = ()=>{
                this.$store.commit('updateFlightSelection',selFlights);
                this.$store.commit('updatePassengerFaresOfSelectedFlights',this.farePassengers);
                this.$store.commit('updateTotalSectors',totsector);
                this.$store.commit('updateFlightSelectionNew',selFlightsNew);
                this.$store.commit('updateOriginM',origin);
                this.$store.commit('updateDestinationM',destination);
                this.$store.commit('updatetrip',"M");                
                this.$router.push({name:'PassengerInfo',params:{sid:this.SearchId}})
            }

            this.saveFareInfoOfSearch(priceBoxId,depFlightGrpIds,fnc);
        },
        isTransit(flights,index){
            return flights[index].Flight.Conx=='Y'||(index>0&& flights[index-1].Flight.Conx!='Y')||index==0
        },

        showHideFlightByDepartureTime(flight){
            var timeSlots = new this.$linq(this.helper.dateAndTime.getTimeSlots(1,1));
            var filterValues = [];
            filterValues[0] = timeSlots.where(s=>s.text==this.departureTimeFilter[0]).toArray()[0];
            filterValues[1] = timeSlots.where(s=>s.text==this.departureTimeFilter[1]).toArray()[0];

            var flightDepartureTime = timeSlots.where(s=>s.text==flight.FlightGroupDepartureTime).toArray()[0];
            var rslt = (flightDepartureTime.key>=filterValues[0].key && flightDepartureTime.key<=filterValues[1].key);
            //flight.DepartureTimeMatched = rslt;
            return rslt;           
        },

        selectFlights(){
            var isselected=true;
            var depFlightGrpIds=[];
            for(let i=0;i<this.searchPara.totalSector;i++){
                if(this.selectedDepartureFlightlst[i].selectedDeparture==null){
                    isselected=false;
                }else{
                    depFlightGrpIds.push(this.selectedDepartureFlightlst[i].selectedDeparture);
                }
            }
            
            if (!isselected){
                this.needDepartureFlight = true;
                return;
            }else{
                this.needDepartureFlight = false;
            }
            
            // if(this.HasReturningFlight==true&&this.selectedReturnFlight==null){
            //     this.needReturnFlight = true;
            //     return;
            // }else{
                this.needReturnFlight = false;
            // }            

            this.flightInfoDialog.show = true;
            this.infoLoaded = false;
            Service.getFlightInfoM(this.SearchId,this.FlightFare,depFlightGrpIds).then(rslt=>{
                this.rules = rslt.Rules;
                this.farePassengers = rslt.FarePassengers;
                this.currency = rslt.FarePassengers[0].Currency;
                this.infoLoaded = true;
            });
        },
        getFareRuleLineStyle(ind){
            var rslt= {};
            rslt.whiteSpace ='pre-wrap';
            if (ind=="F"){
                rslt.color = theme.primary.base;
                rslt.fontWeight = 'bold';
            }else{
                rslt.color = 'none';
            }
            return rslt;
        },
        getPassengerTypeDesc(numCode){
            let names = ["Adults","Children","Infants","Students"];
            let codes = [5,0,55,114];
            let idx = codes.indexOf(numCode);
            if (idx < 0 ) return "";
            return names[idx];
        },
        getTotalPrice(farePassengers){
            let fp = farePassengers;

            let totalPrice = 0;
            fp.forEach((p,i)=>{
                totalPrice += p.Count * (p.Price+p.Tax+p.QSercharge);
            });
 
            this.compareTotalPriceToConfirmedTotalPrice(totalPrice);          
            return totalPrice;
        },
        getAirportCode(ap){
            try {
                var code = ap.split('-')[0];
                code = code.trim();                
                return code;            
            } catch (error) {
                return "";
            }
        },
    }
}
</script>

<style>
.price-card{
    margin-right:0px;
    text-align: center;
}
.price-card div span{
    font-size: 17px;
    font-weight: bold;
}
.price-grid-cell{
    text-align: right;
}
.border-left{
    border-left-style: solid;
    border-left-width: 2px;
}
.full-height{
    height:100%;
}
.dvsectors .theme--light.v-messages{
    display: none;
}
</style>


